export default __webpack_public_path__ + "static/process-1-ffb3eed91163d944138d64dc6034dd28.png";